import React from 'react';
import PropTypes from 'prop-types';

function LinkedInIcon({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M18.2917 32.625H11.125V11.125H18.2917V14.7083C19.8192 12.7648 22.1359 11.6062 24.6073 11.5496C29.0517 11.5743 32.6379 15.191 32.625 19.6354V32.625H25.4583V20.5312C25.1717 18.5292 23.4549 17.0439 21.4325 17.0482C20.5479 17.0762 19.7128 17.4636 19.1201 18.1207C18.5275 18.7781 18.2282 19.6485 18.2917 20.5312V32.625ZM7.54167 32.625H0.375V11.125H7.54167V32.625ZM3.95833 7.54167C1.97931 7.54167 0.375 5.93735 0.375 3.95833C0.375 1.97931 1.97931 0.375 3.95833 0.375C5.93735 0.375 7.54167 1.97931 7.54167 3.95833C7.54167 4.90869 7.16414 5.82013 6.49213 6.49213C5.82013 7.16414 4.90869 7.54167 3.95833 7.54167Z" fill={color} />
    </svg>

  );
}

LinkedInIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

LinkedInIcon.defaultProps = {
  color: '#7ED321',
  width: '39',
  height: '39',
};

export default React.memo(LinkedInIcon);
